/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-23, 16:28:53
 * Author: Michał Rejman <michal.rejman@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-03-05, 14:57:33
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */

import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  billingList: {
    terms: {
      dateStart: null,
      dateEnd: null,
      sort: 'desc',
      sortBy: 'date',
      page: 1,
    },
    data: [],
    summary: {},
    count: 0,
  },
};

const getters = {
  billingList: state => state.billingList,
  billingListActualPage: state => state.billingList.terms.page,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;



// WEBPACK FOOTER //
// ./src/store/modules/Billing/index.js